import { getInvoicesId } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const getInvoiceByIdQueryKey = (invoiceId: number) => {
	return ["INVOICE_BY_ID", invoiceId];
};

export function useInvoiceById(invoiceId: number) {
	return useQuery({
		queryKey: getInvoiceByIdQueryKey(invoiceId),
		queryFn: processResponse(() => getInvoicesId(invoiceId!)),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
	});
}
